import {isScrolledIntoView} from "../utils/utils";
import HtmlVideoPlayer from "../components/HtmlVideoPlayer";
import Nav from "../components/Nav";

export default class Asset {
	constructor() {
		this.loadMoreBottom 	= document.getElementById('load-more-bottom');
		this.runFilters 		= document.getElementById('run-filters');
		this.browseFilters 		= document.querySelectorAll('.filter');
		this.checkboxFilters 	= document.querySelectorAll('.check-filter');
		this.tagFilters 		= document.querySelectorAll('.tag-filter');
		this.resetFilters 		= document.getElementById('reset-filters');
		this.barLoadMore		= document.getElementById('load-more-form');

		if(this.barLoadMore) {
			this.barLoadMore.addEventListener("click", (event) => {
				event.preventDefault();
				document.getElementById('run-filters').click();
			});
		}

		if(this.loadMoreBottom) { 
			this.loadMoreBottom.style.display = "none";
			let timer;
			window.addEventListener("scroll", (event) => {
				clearTimeout(timer);
				timer = setTimeout(() => {
					if(this.loadMoreBottom.disabled === false) {
						if (isScrolledIntoView(this.loadMoreBottom)) {
							this.loadMoreBottom.style.display = "block";
							this.loadMoreBottom.disabled = true;
							document.body.classList.remove("loaded");
							this.veritoneLoadMore('loadMore');
						}
					}
				}, 250);
			});
		}

		if(this.browseFilters) {
			this.browseFilters.forEach((filter) => {
				filter.addEventListener("change", (event) => {
					event.preventDefault();
					if( event.target.parentNode.classList.contains('tag') ){
						event.target.parentNode.classList.toggle('tag--active')
					}
				});
			});
		}

		if(this.runFilters) {
			this.runFilters.addEventListener("click", (event) => {
				event.preventDefault();
				document.getElementById('queryString').value = '';
				this.veritoneLoadMore('filterChange');
			});
		}

		if(this.resetFilters) {
			this.resetFilters.addEventListener("click", (event) => {
				event.preventDefault();
				document.getElementById('queryString').value = '';
				document.querySelectorAll(".filter").forEach((filter) => {
					filter.checked = false;
					filter.parentElement.classList.remove('tag--active');
				});
			});
		}


		// if(document.getElementById('filters-window')) {
		// 	document.addEventListener("click", (event) => {
		// 		if (!event.target.closest('#filters-window') && !event.target.parentElement.classList.contains('filters-window-button')) {
		// 			if(document.querySelector('#filters-window').classList.contains('dialog--open')) {
		// 				document.querySelector('#filters-window').classList.remove('dialog--open');
		// 			}
		// 		}
		// 	})
		// }
	}

	// Veritone Load More
	veritoneLoadMore(action) {
		document.body.classList.remove("loaded");
		let formData 			= new FormData(document.getElementById("load-more"));
		let collectionID		= false;
		let loadMoreContainer  			= document.getElementById('load-more-container');
		let loadMoreBottom 				= document.getElementById('load-more-bottom');
		let totalAssets  				= document.getElementById('total-assets');
		let relatedSearches  			= document.getElementById('related-searches');
		let currentlyTrendingContainer  = document.getElementById('currently-trending');
		let currentlyTrendingTiles  	= document.getElementById('currently-trending__tiles');
		let queryStringInput		  	= document.getElementById('queryString');

		// Add the form action to formData
		formData.append("function", action);

		if(document.getElementById("collectionID")) {
			let collectionID = document.getElementById("collectionID").value;
			if(collectionID) {
				formData.append("collectionID", collectionID);
			}
		}

		// Tidying up the query parameters the user will copy
		let paramsToCopy = new URLSearchParams(formData);
		let keysForDel = [];
		paramsToCopy.forEach((value, key) => {
			if (value == '') {
				keysForDel.push(key);
			}
			if(key === 'page' || key === 'toShow' || key === 'function' || key === 'viewType') {
				keysForDel.push(key);
			}
		});

		keysForDel.forEach(key => {
			paramsToCopy.delete(key);
		});

		if(action === 'filterChange') {
			queryStringInput.value = paramsToCopy.toString();
			console.log(queryStringInput.value);
		}

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneLoadMore', {
			method: 'POST',
			body: new URLSearchParams(formData),
		})
		.then(response => response.json())
		.then(data => {
			if(data['items']) {
				// If assets are found
				if(data['action'] === 'loadMore') {
					// Loop through each asset and display on page
					data['items'].forEach((asset) => {
						loadMoreContainer.insertAdjacentHTML('beforeend', asset);
					});
				} else if(data['action'] === 'filterChange') {
					// Clear page and present new assets based on filter change
					loadMoreContainer.innerHTML = "";
					totalAssets.innerHTML = data['totalCount'];
					data['items'].forEach((asset) => {
						loadMoreContainer.insertAdjacentHTML('beforeend', asset);
					});
				}

				if(currentlyTrendingTiles) {
					currentlyTrendingTiles.innerHTML = "";
					currentlyTrendingContainer.style.display = 'none';
				}

				// Increment page counter by 1 ready for next request
				document.getElementById('currentPage').value = data['currentPage'] + 1;
			} else if(data['error']) {
				// If error, clear load more and display error
				loadMoreContainer.innerHTML = "";
				totalAssets.innerHTML = '0';
				loadMoreContainer.insertAdjacentHTML('beforeend', data['error']);
				if(data['currentlyTrending'] && currentlyTrendingTiles) {
					currentlyTrendingTiles.innerHTML = "";
					currentlyTrendingTiles.insertAdjacentHTML('beforeend', data['currentlyTrending']);
					currentlyTrendingContainer.style.display = 'block';
				}
			}

			if(relatedSearches) {
				if(data['relatedTags']) {
					// If search has related dictionary terms, display them
					relatedSearches.style.display = "flex";
					relatedSearches.innerHTML = '';
					let tags = '<span>Related Searches</span>';
					data['relatedTags']['list'].forEach((relatedTag) => {
						tags += '<a class="tag" href="/browse?search='+relatedTag+'">'+relatedTag+'</a>';
					});
					relatedSearches.innerHTML = tags;
				} else {
					relatedSearches.style.display = "none";
					relatedSearches.innerHTML = '';
				}
			}

			loadMoreBottom.style.display = "none";
			document.body.classList.add("loaded");

			if(data['hasNextPage']) {
				document.getElementById('load-more-bottom').disabled = false;
			}

			this.hoverVideos = document.querySelectorAll('.video--hover');
			this.hoverVideos && this.hoverVideos.forEach((video)=>
			{

				let options =
					{
						autoplay: false,
						loop: true,
						muted: true,
						controls: false,
						progress: false,
						cover: false,
						hoverToPlay: true,
					}

				if( video.classList.contains('video--cover') ){
					options.cover = true;
				}

				new HtmlVideoPlayer(video, options);

			})

			this.showSensitiveButtons = document.querySelectorAll('.show-sensitive');
			this.showSensitiveButtons && this.showSensitiveButtons.forEach((button)=>
			{
				button.addEventListener("click", (event) => {
					console.log('sensitive click');
					button.closest('.tile-video, .tile-video-list, .tile-video-basic').classList.remove('tile--sensitive');
				});
			})

			this.addToCollectionActions = document.querySelectorAll('.add-to-collection-form');
			if(this.addToCollectionActions) {
				this.addToCollectionActions.forEach((addToCollectionAction) => {
					addToCollectionAction.addEventListener("click", (event) => {
						console.log('Asset.js');
						event.preventDefault();
						let formData 	            = new FormData(addToCollectionAction);
						let collectionErrors				= document.getElementById("create-collection-errors");

						fetch('/wp/wp-admin/admin-ajax.php?action=veritoneAddToCollection', {
							method: 'POST',
							body: formData,
						})
						.then(response => response.json())
						.then(data => {
							if(data['fieldErrors']) {
								data['fieldErrors'].forEach((error) => {
									collectionErrors.innerHTML += error['message'];
								});
								collectionErrors.classList.add('form-group__errors--open');
							} else {
								console.log('Added to Collection');

								let formData= new FormData();
								let modalName = 'added-to-collection';
								formData.append('modalName', modalName);

								fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
									method: 'POST',
									body: formData,
								})
								.then(response => response.json())
								.then(data => {
									document.querySelector('#modal__shell .modal__content').innerHTML = '';
									document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
									document.querySelector('#modal__shell').classList.add('modal--large');
									document.body.classList.add('modal--open');
									document.body.classList.add("loaded");
								})
							}
							document.body.classList.add("loaded");
						})
					});
				});
			}
		})
		// .catch(function(error) {
		// 	console.log('Request Failed', error);
		// 	loadMoreBottom.dataset.loading = 'false';
		// 	document.body.classList.add("loaded");
		// });
	}
}